import PropTypes from 'prop-types'
import React from 'react'
import { platformTransitionStyle } from '../../../../shared/helpers'
import focusable from '../../components/Focusable/Focusable'
import tts from '../../lib/TTS'
import GridItem from '../GridItem/GridItem'

class Grid extends React.PureComponent {
  constructor(props) {
    super(props)

    this.focusedIndex = 0
    this.items = []
    this.header = this.props.parent.header || this.props.parent.state.header

    this.traversalInteger = props.view === 'show' ? 5 : 4

    this.state = {
      verticalOffset: 0,
    }
    this.gridItemRef = React.createRef()
  }

  onKeyEvent(key) {
    let handled = false
    tts.stopRead()

    if (key === 'LEFT') {
      if (0 !== this.focusedIndex) {
        this.focusedIndex--
        this.items[this.focusedIndex]?.setFocus()

        if ((this.focusedIndex + 1) % this.traversalInteger === 0) {
          const gridItem =
            this.items[this.focusedIndex]?.instance?.gridLinkRef?.current

          this.setState({
            verticalOffset: `-${gridItem.offsetTop}`,
          })
        }

        handled = true
      }
    } else if (key === 'RIGHT') {
      if (this.items.length !== this.focusedIndex + 1) {
        this.focusedIndex++
        this.items[this.focusedIndex]?.setFocus()

        if ((this.focusedIndex + 1) % this.traversalInteger === 0) {
          const gridItem =
            this.items[this.focusedIndex]?.instance?.gridLinkRef?.current

          this.setState({
            verticalOffset: `-${gridItem.offsetTop}`,
          })
        }

        handled = true
      }
    } else if (key === 'DOWN') {
      if (this.items.length + 1 >= this.focusedIndex + this.traversalInteger) {
        this.focusedIndex += this.traversalInteger

        // There are no more rows below the current focused Item go right to the last item
        // and set that as the focus
        let gridItem
        if (this.focusedIndex >= this.items.length - 1) {
          gridItem =
            this.items[this.items.length - 1]?.instance?.gridLinkRef?.current

          this.focusedIndex = this.items.length - 1
        } else {
          //If the next item is out of view, move the screen down
          gridItem =
            this.items[this.focusedIndex]?.instance?.gridLinkRef?.current
        }
        this.setState({
          verticalOffset: `-${gridItem.offsetTop}`,
        })
        this.items[this.focusedIndex]?.setFocus()

        if (this.items.length - this.focusedIndex < this.traversalInteger * 3) {
          this.props.handleNearEndOfGrid()
        }
        handled = true
      }
    } else if (key === 'UP') {
      if (this.items.length !== this.focusedIndex - this.traversalInteger) {
        if (this.focusedIndex - this.traversalInteger < 0) {
          handled = true
          //WE are at the top of the window
        } else {
          this.focusedIndex -= this.traversalInteger

          const gridItem =
            this.items[this.focusedIndex]?.instance?.gridLinkRef?.current

          this.setState({
            verticalOffset: `-${gridItem.offsetTop}`,
          })

          this.items[this.focusedIndex]?.setFocus()
          handled = true
        }
      }
    }

    return handled
  }

  setChildFocus() {
    if (this.items.length < 1) {
      return
    }
    const currentFocusedItem = this.items[this.focusedIndex]
    const currentFocusedTitle =
      currentFocusedItem &&
      currentFocusedItem.props &&
      currentFocusedItem.props.content &&
      currentFocusedItem.props.content.title
    const windowFocusedTitle =
      window.focusedComponent &&
      window.focusedComponent.props &&
      window.focusedComponent.props.content &&
      window.focusedComponent.props.content.title

    if (
      'undefined' !== typeof currentFocusedItem &&
      currentFocusedTitle !== windowFocusedTitle
    ) {
      currentFocusedItem?.setFocus()
    }
  }

  setGridItemRefs = (element) => {
    this.gridItemRef = element
    this.items.push(element)
  }

  render() {
    const { collection, collectionType } = this.props
    this.textToRead = []
    return (
      <div className="grid-container">
        {'undefined' !== typeof collection && 0 !== collection.length && (
          <div id={`grid`}>
            <div
              className="grid-header"
              ref={(text) => (text ? this.textToRead.push(text.innerText) : '')}
              style={{
                transition: platformTransitionStyle(
                  'transform 400ms ease-in-out'
                ),
                transform: `translateY(${this.state.verticalOffset}px)`,
              }}
            >
              {this.header}
            </div>
            <div className="grid-slider">
              <div
                className="grid-item-wrapper"
                style={{
                  transition: platformTransitionStyle(
                    'transform 400ms ease-in-out'
                  ),
                  transform: `translateY(${this.state.verticalOffset}px)`,
                }}
              >
                {collection.map((r, i) => {
                  return (
                    <GridItem
                      collectionType={collectionType}
                      parent={this}
                      key={i}
                      index={i}
                      content={r}
                      ref={this.setGridItemRefs}
                      view={r.item_type}
                    />
                  )
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

Grid.propTypes = {
  collection: PropTypes.array,
  collectionType: PropTypes.string,
  id: PropTypes.string,
  parent: PropTypes.shape({
    header: PropTypes.string,
    state: PropTypes.shape({
      header: PropTypes.string,
    }),
  }),
  view: PropTypes.string,
  handleNearEndOfGrid: PropTypes.func,
}

export default focusable(Grid)
